import { RouterProvider } from "react-router-dom";
import routes from "./routes/routes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SaasSessionProvider } from './saas/SessionContext';

function App() {
  return (
    <SaasSessionProvider>
      <RouterProvider router={routes} />
      <ToastContainer />
    </SaasSessionProvider>
  );
}

export default App;
